(ns frontend.view.grid.counterparty-diligence-grid.project.db
  (:require
   [frontend.db :as app-db]
   [reagent.core :as r]))

(defonce project-counterparty-diligences (r/cursor app-db/views [:project-counterparty-diligence-grid]))
(defonce modal-state (r/cursor project-counterparty-diligences [:modals]))
(defonce grid-entities (r/cursor project-counterparty-diligences [:grid-entities]))
(defonce view-settings (r/cursor project-counterparty-diligences [:view-settings]))
(defonce project-counterparty-diligence-filters (r/cursor view-settings [:filters]))
(defonce selected-columns (r/cursor view-settings [:selected-columns]))
(defonce column-widths (r/cursor view-settings [:column-widths]))
(defonce ordered-columns (r/cursor view-settings [:ordered-columns]))

;;kanban related definitions
(defonce kanban (r/cursor project-counterparty-diligences [:kanban]))
(defonce expanded (r/cursor kanban [:expanded]))
(defonce grouped-by (r/cursor view-settings [:grouped-by]))
(defonce card-settings (r/cursor view-settings [:card-settings]))
(defonce lists (r/cursor kanban [:lists]))
(defonce sorted-kanban-entities (r/cursor project-counterparty-diligences [:sorted-kanban-entities]))

;;precalculated schema (for performance reasons):
(defonce schema (r/cursor project-counterparty-diligences [:schema]))
